// extracted by mini-css-extract-plugin
export default {"eventid":"Page_eventid__7jjZR"};